export const compareNatural = (
  a: string | number,
  b: string | number,
): number =>
  typeof a === 'number' && typeof b === 'number'
    ? a - b
    : String(a).localeCompare(String(b), undefined, { numeric: true })
